import {
  faUser,
  faCommentDots,
  faCalendarPlus,
  faCalendarAlt,
  faTrash,
  faUsers,
  faCreditCard,
  faComments,
  faCog,
  faAdd,
  faSignOutAlt,
  faHome,
  faInfoCircle,
  faNewspaper,
  faHeadset,
  faClipboardCheck,
  faDashboard,
  faPlusSquare,
  faCrown,
  faCheckToSlot,
  faClipboardList,
  faTags,
} from "@fortawesome/free-solid-svg-icons";

export const menuItems = [
  {
    type: "item",
    label: "لاگ سیستم",
    icon: faClipboardList,
    path: "/admin/audit-logs",
    roles: ["Admin"],
    auth: ["auth"],
  },
  {
    type: "item",
    label: "مدیریت اشتراک",
    icon: faCrown,
    path: "/subscription",
    roles: ["Admin", "Doctor", "Secretary"],
    auth: ["auth"],
  },
  {
    type: "item",
    label: "پلن‌ها و قیمت اشتراک",
    icon: faTags,
    path: "/admin/subscription/plans",
    roles: ["Admin"],
    auth: ["auth"],
  },
  {
    type: "item",
    label: "داشبورد",
    icon: faDashboard,
    path: "/dashboard",
    roles: ["Admin", "Doctor"],
    auth: ["auth"],
  },
  {
    type: "item",
    label: "حساب کاربری من",
    icon: faUser,
    path: "/user",
    auth: ["auth"],
  },
  {
    type: "item",
    label: "نوبت های من",
    icon: faCheckToSlot,
    path: "/reservation/userReserves",
    auth: ["auth"],
  },
  {
    type: "item",
    label: "مشاوره های من",
    icon: faCommentDots,
    path: "/counseling/index",
    auth: ["auth"],
  },
  { type: "divider", auth: ["auth"] },

  {
    type: "item",
    label:"مشاوره‌های پزشک",
    icon: faComments,
    path: "/counseling/doctorChats",
    state: { status: "active" },
    roles: ["Admin", "Doctor"],
    auth: ["auth"],
  },
  {
    type: "item",
    label: "ایجاد مشاوره جدید",
    icon: faAdd,
    path: "/counseling/createConsultation",
    roles: ["Admin", "Doctor", "Secretary"],
    auth: ["auth"],
  },

  { type: "divider", auth: ["auth"] },
  {
    type: "item",
    label: "صفحه اصلی",
    icon: faHome,
    path: "/",
    auth: ["guest"],
  },
  {
    type: "item",
    label: "درباره پزشک",
    icon: faInfoCircle,
    path: "/about",
    auth: ["guest", "auth"],
  },
  {
    type: "item",
    label: "مشاهده مقالات",
    icon: faNewspaper,
    path: "/blog/index",
    auth: ["guest", "auth"],
  },
  {
    type: "item",
    label: "پشتیبانی",
    icon: faHeadset,
    path: "/support",
    auth: ["guest", "auth"],
  },

  {
    type: "item",
    label: "ثبت رزرو",
    icon: faCalendarPlus,
    path: "/Reservation/manualReserve",
    roles: ["Admin", "Doctor", "Secretary"],
    auth: ["auth"],
  },
  {
    type: "item",
    label: "تمام رزرو ها",
    icon: faCalendarAlt,
    path: "/Reservation/allReserves",
    roles: ["Admin", "Doctor", "Secretary"],
    auth: ["auth"],
  },
  {
    type: "item",
    label: "حذف گروهی نوبت رزرو",
    icon: faTrash,
    path: "/Reservation/reserveException",
    roles: ["Admin", "Doctor", "Secretary"],
    auth: ["auth"],
  },
  {
    type: "item",
    label: "کاربران",
    icon: faUsers,
    path: "/user-index",
    roles: ["Admin", "Doctor", "Secretary"],
    auth: ["auth"],
  },

  {
    type: "item",
    label: "تراکنش ها",
    icon: faCreditCard,
    path: "/payment/succesPayments",
    roles: ["Admin", "Doctor"],
    auth: ["auth"],
  },

  { type: "divider", roles: ["Admin", "Doctor"], auth: ["auth"] },

  {
    type: "item",
    label: "ایجاد مقاله جدید",
    icon: faPlusSquare,
    path: "/blog/create",
    roles: ["Admin", "Doctor", "Secretary"],
    auth: ["auth"],
  },

  { type: "divider", roles: ["Admin", "Doctor", "Secretary"], auth: ["auth"] },

  {
    type: "item",
    label: "بررسی نظرات کاربران",
    icon: faClipboardCheck,
    path: "Comment/uncheck",
    roles: ["Admin", "Doctor", "Secretary"],
    auth: ["auth"],
  },
  {
    type: "item",
    label: "تنظیمات سیستم",
    icon: faCog,
    path: "Setting/app-setting",
    roles: ["Admin", "Doctor", "Secretary"],
    auth: ["auth"],
  },

  { type: "divider", auth: ["auth"] },
  {
    type: "item",
    label: "خروج از حساب کاربری",
    icon: faSignOutAlt,
    onClick: "logout",
    auth: ["auth"],
  },
];
